import img1 from '../media/partners/amil_195px_80px-01.png'
import img2 from '../media/partners/centauro_344px_113px-02.png'
import img3 from '../media/partners/icatu_214px_172px-03.png'
import img4 from '../media/partners/MAG_169px_76px-04.png'
import img5 from '../media/partners/metlife_350px_75px-05.png'
import img6 from '../media/partners/sulamerica_308px_116px-06.png'
import img7 from '../media/partners/porto seguro_285px_111px-07.png'
import img8 from '../media/partners/bradescosaude_320px_115px-15.png'
export const partners = [
    {
        name: 'Amil',
        href: '',
        imgUrl: img1,
        minHeight: '',
        minWidth: ''
    },
    {
        name: 'Centauro - Seguros',
        href: '',
        imgUrl: img2,
        minHeight: '',
        minWidth: ''
    },
    {
        name: 'Icatu - Seguros',
        href: '',
        imgUrl: img3,
        minHeight: '100px',
        minWidth: '80px'
    },
    {
        name: 'MAG - Seguros',
        href: '',
        imgUrl: img4,
        minHeight: '',
        minWidth: ''
    },
    {
        name: 'Metlife - Saúde',
        href: '',
        imgUrl: img5,
        minHeight: '',
        minWidth: ''
    },
    {
        name: 'SulAmérica - Saúde',
        href: '',
        imgUrl: img6,
        minHeight: '',
        minWidth: ''
    },
    {
        name: 'Porto Seguros',
        href: '',
        imgUrl: img7,
        minHeight: '',
        minWidth: '150px'
    },
    {
        name: 'Bradesco - Saúde',
        href: '',
        imgUrl: img8,
        minHeight: '',
        minWidth: ''
    }
]
